import * as Constants from '../../../helpers/Constants'

const Styles = {
  container: {
    position: 'absolute',
    top: 32,
    left: 1,
    display: 'flex',
    flexDirection: 'row'
  },
  dotContainer: {
    flexDirection: 'row',
    marginTop: 0
  },
  dot: {
    width: 5,
    height: 5,
    borderRadius: 2.5,
    marginLeft: 1,
    marginBottom: 0.1,
    marginRight: 1,
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/containers/CalendarDots/styles.js